/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'file/txt': {
    width: 48,
    height: 48,
    viewBox: '0 0 48 48',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M9 3a2 2 0 00-2 2v38a2 2 0 002 2h30a2 2 0 002-2V16.414c0-.081-.005-.162-.015-.242a1.004 1.004 0 00-.41-.99 1.978 1.978 0 00-.16-.182L29 3.586a1.986 1.986 0 00-.182-.161.999.999 0 00-.99-.41A2 2 0 0027.586 3H9zm18 2H9v38h30V17H28a1 1 0 01-1-1V5zm10.586 10L29 6.414V15h8.586z" _fill="#0B2C62"/><path pid="1" _fill="#0B2C62" d="M8 22h26v15H8z"/><path pid="2" d="M12.396 25.454v1.1h1.957V33h1.386v-6.446h1.959v-1.1h-5.303zm5.614 0l2.211 3.619L17.768 33h1.342l1.793-2.937L22.63 33h1.606l-2.453-4.048 2.145-3.498h-1.342l-1.485 2.541-1.485-2.541H18.01zm6.288 0v1.1h1.958V33h1.386v-6.446H29.6v-1.1h-5.302z" _fill="#fff"/>'
  }
})
